module.exports = __webpack_public_path__ + "static/centraliser-donnees.14425800.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/centraliser-donnees.png
// module id = 102
// module chunks = 12729642909824 28686525722576 213628377533538